import React from "react";
import styles from "./styles.module.css";

const HeaderMessageBar = ({ message }) => {
  return <div className={styles.messageBarContainer}>{message}</div>;
};

export default HeaderMessageBar;
